import React, { useState, useEffect } from "react";
import axios from "axios";import "./static/css/profile.css";

import { useNavigate } from "react-router-dom";
import ErrorMessage from "../ErrorMessage";
import ProductCard from "../../Products/ProductCard";
import UserAddresses from "./UserAddresses"
import PurchaseConfirmationModal from "./PurchaseConfirmationModal";
import {ProgressBar}  from "react-bootstrap";

export default function Profile( {onLogout} ) {
  const statusMap = {
    pending: { label: "Ожидает обработки", percentage: 0 },
    processing: { label: "В обработке", percentage: 25 },
    shipped: { label: "Отправлен", percentage: 50 },
    out_for_delivery: { label: "В пути", percentage: 75 },
    delivered: { label: "Доставлен", percentage: 100 },
  };
  const [user, setUser] = useState({});
  const [orders, setOrders] = useState({})
  const token = localStorage.getItem("access_token");
  const [showMessage, setShowMessage] = useState(false);
  const [showAddress, setShowAddress] = useState(false);
  const [showPurchaseConfirmationModal, setShowPurchaseConfirmationModal] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    if (!token) {
      logout();
      setShowMessage(true);
      setTimeout(() => {
        setShowMessage(false);
        navigate("/user/login");
      }, 1500);

      return;
    }

    axios
      .get("https://monkeprogrammer01.pythonanywhere.com/user/profile/", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setUser(response.data); // Save the data in state
      })
      .catch((error) => {
        setShowMessage(true);
        setTimeout(() => {
          setShowMessage(false);
          navigate("/user/login"); // Redirect to login page
        }, 1500);


        console.error(error);
      });    
      axios.get("https://monkeprogrammer01.pythonanywhere.com/payment/get-my-orders/", {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        setOrders(response.data)
      }) .catch( (error) => {
        console.error(error);
      })
  }, [token]);


  const handleSelectAddress = async (address) => {
    try {
        await axios.post(
        'https://monkeprogrammer01.pythonanywhere.com/payment/order/', {selectedAddress: address},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
        );  
        setShowAddress(false);
        setShowPurchaseConfirmationModal(true)
        setTimeout(() => {
                setShowPurchaseConfirmationModal(false);
                window.location.reload()
        }, 1500);
    } catch {} 
 
  };

  const handleAddAddress = async (e) => {
 
    navigate("/user/customer-form?redirect=/user")

  }

  const handleOrderSubmit = async (e) => {
    e.preventDefault();
    setShowAddress(true);
     }
  const orderList = Array.isArray(orders) ? orders : [];

  const basket = Array.isArray(user.basket) ? user.basket : [];
  const [basketSum, setBasketSum] = useState(0);

  useEffect(() => {
    if (user.sum !== undefined) {
      setBasketSum(user.sum);
    }
  }, [user.sum]);
  const handleIncrease = async (product) => {
    const updateCurrentSum = async (newSum) => {
      setBasketSum(newSum);
    };

    const data = {
      product: product.id,
      action: "add",
    };
    try {
      await axios.post("https://monkeprogrammer01.pythonanywhere.com/products/add/", data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
    } catch {
      console.error("Error updating product");
    }
  };

  const logout = () => {
    localStorage.removeItem("access_token");
    setUser({});
    setOrders([]);
    window.location.href = "/user/login";
  };

  return (
    <>
      <PurchaseConfirmationModal 
        isOpen={showPurchaseConfirmationModal} 
        onClose={() => {
          setShowPurchaseConfirmationModal(false); 
          window.location.reload();
        }} 
      />
      <UserAddresses
        show={showAddress}
        handleClose={() => setShowAddress(false)}
        handleAddAddress={handleAddAddress}
        onSelectAddress={handleSelectAddress}
      />
      <div className="profile-container">
        <h1>Ваш Профиль</h1>
        <div className="profile-card">
          <div className="profile-info">
            <p>
              <strong>Email:</strong> {user.email}
            </p>
          </div>
        </div>
        <button onClick={onLogout} className="btn btn-danger">
          Выйти из аккаунта
        </button>
        {user.is_verified &&         <button onClick={logout} className="btn btn-danger">
          Подтвердить почту
        </button>}
      </div>
      <div className="profile-page">
              <div className="basket" >
              {basket.length === 0 ? (
        <div className="text-center">
          <h4 className="text-muted">🛒 Ваша корзина пуста</h4>
          <p>Добавьте товары, чтобы оформить заказ.</p>
        </div>
      ) : (
        <div>
                <button className="btn btn-warning"><h4>Моя корзина</h4></button>
      {basket.map((product) => (
        <ProductCard
          key={product[0].product_id}
          product={product[0]}
          quantity={product[1]}
          showQuantity={true}
          sum={basketSum}
          updateBasketSum={(diff) => setBasketSum((prev) => prev + diff)}
        />
      ))}
      { basketSum > 0 &&       <div className="payment">
        <h3>Итого: {basketSum} KZT.</h3>
        <button className="product-card__button" onClick={handleOrderSubmit}>Заказать</button>
        </div> }
        </div>
      )}


      </div>
      
      <div className="orders">
      {orderList.length === 0 ? (
        <div className="text-center">
          <h4 className="text-muted">📦 У вас пока нет заказов</h4>
          <p>Оформите заказ, и он появится здесь.</p>
        </div>
      ) : (
        <div>
          <button className="btn btn-danger"><h4>Мои заказы</h4></button>

          {orderList.map((order) => (
            <div key={order.id} className="card mb-3">
              <div className="card-body">
                <h5 className="card-title">Заказ #{order.id}</h5>
                <p className="card-text">Статус: {statusMap[order.status].label}</p>  
                <ProgressBar now={statusMap[order?.status]?.percentage || 0}  label={`${statusMap[order.status].percentage}%`} />

                <p className="card-text">Сумма: {order.total_price}₸</p>
              </div>
            </div>
          ))}
        </div>
      )}
      </div>
      </div>


      {showMessage && (
        <ErrorMessage
          onClose={() => setShowMessage(false)}
          message="You are not logged in!"
        />
      )}
    </>
  );
}


